import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Filter from "../components/Filter";

export default class PageMedias {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());

    this.loading = false

    this.queryValues = {
      'pages': 1,
    }
  }

  async init() {
    this.initResponsiveHelper();
    this.initPagination()
  }



  initResponsiveHelper() {

  }

  initPagination() {
    const pages = document.querySelectorAll('.www-pagination .page-link')
    if (pages) {
      pages.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()

          if (this.loading) {
            return
          }

          this.queryValues['pages'] = parseInt(item.dataset.page)
          this.historyPushState('pages', parseInt(item.dataset.page))
          this.fetchData()
        })
      });
    }
  }

  historyPushState(type, val) {
    const url = new URL(window.location);
    url.searchParams.set(type, val);
    window.history.pushState({}, "", url);
  }

  fetchData() {

    this.loading = true

    fetch("?api=getMediaItems", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.queryValues),
    })
    .then((response) => response.json())
    .then((response) => {
      this.loading = false

      let old_items = document.querySelector("[js-media-items]");
      let old_pagination = document.querySelector("[js-pagination]");

      let new_items = document.createElement("div");
      new_items.innerHTML = response.items.trim();
      let new_pagination = document.createElement("div");
      new_pagination.innerHTML = response.pagination.trim();

      old_items.parentNode.replaceChild(new_items.firstChild, old_items);
      old_pagination.parentNode.replaceChild(new_pagination.firstChild, old_pagination);

      gsap.to(window, {
        duration: .35,
        scrollTo: 0
      })

      this.initPagination()
    })
  }

  resize() {
  }

  destory() {

  }
}
